/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTenFeet32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M23.969 8.479h-1.893v-.34c0-.575.307-.82 1.03-.82.283 0 .555.021.863.075V6.117A5.785 5.785 0 0022.797 6c-1.822 0-2.745.713-2.745 2.117v.362H18.75V9.67h1.302v4.128h2.024V9.67h1.893V8.48z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.959 10.106c0 2.437-1.598 3.894-4.083 3.894-2.485 0-4.07-1.457-4.07-3.894 0-2.446 1.585-3.904 4.07-3.904 2.485 0 4.083 1.458 4.083 3.904zm-6.047 0c0 1.66.769 2.511 1.964 2.511 1.207 0 1.976-.851 1.976-2.51 0-1.67-.769-2.522-1.976-2.522-1.195 0-1.964.851-1.964 2.521z'
      />
      <path
        fill='currentColor'
        d='M6.142 13.798H4.106V8.766c-.343.308-.982.49-1.692.49H2V7.66h.26c1.124-.022 1.823-.426 2.19-1.256h1.692v7.394zM26.024 9.67h-1.337V8.48h1.337V7.213l2.023-.681v1.947H30V9.67h-1.953v1.862c0 .628.367.936 1.113.936.343 0 .615-.043.84-.085v1.383a5.964 5.964 0 01-1.373.149c-1.81 0-2.603-.692-2.603-1.979V9.67z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1.25 18.25v7.5h29.5v-7.5H1.25zm1.5 6v-4.5h2v1.75h1.5v-1.75h1.5v1.75h1.5v-1.75h1.5v2.75h1.5v-2.75h1.5v1.75h1.5v-1.75h1.5v1.75h1.5v-1.75h1.5v2.75h1.5v-2.75h1.5v1.75h1.5v-1.75h1.5v1.75h1.5v-1.75h2v4.5H2.75z'
      />
    </svg>
  );
}

export default SvgTenFeet32;
